import {
  Briefcase,
  Car,
  CreditCard,
  GraduationCap,
  HandCoins,
  Question,
  House,
  ShoppingBag,
} from '@phosphor-icons/react';

import pt from '../../locales/pt';

export const DEBT_TYPE_META = [
  { value: 'mortgage', icon: House, color: '#6B8FA8' },
  { value: 'auto', icon: Car, color: '#9CA3AF' },
  { value: 'consumer', icon: ShoppingBag, color: '#D4A574' },
  { value: 'credit_card', icon: CreditCard, color: '#C45C5C' },
  { value: 'student', icon: GraduationCap, color: '#6B8FA8' },
  { value: 'business', icon: Briefcase, color: '#7C9E6F' },
  { value: 'personal_loan', icon: HandCoins, color: '#A67C52' },
  { value: 'other', icon: Question, color: '#9CA3AF' },
];

export const DEBT_TYPES = DEBT_TYPE_META.map((item) => item.value);

export const DEBT_PURPOSES = ['necessity', 'desire', 'investment'];

export const INVESTMENT_RETURN_TYPES = ['monetary', 'education', 'other'];

export const PAYMENT_RECURRENCES = ['monthly', 'quarterly', 'semi_annual', 'annual'];

/** Months covered by each payment recurrence (single source of truth). */
export const PAYMENT_RECURRENCE_MONTHS = {
  monthly: 1,
  quarterly: 3,
  semi_annual: 6,
  annual: 12,
};

export function debtTypeMeta(value) {
  return (
    DEBT_TYPE_META.find((item) => item.value === value) || {
      value: 'other',
      icon: Question,
      color: '#9CA3AF',
    }
  );
}

export function debtTypeLabel(type) {
  return pt.liabilities.types[type] || type;
}

export function purposeLabel(value) {
  return pt.liabilities.purpose[value] || value;
}

export function investmentReturnTypeLabel(value) {
  return pt.liabilities.investmentReturnType[value] || value;
}

export function classificationLabel(value) {
  return pt.liabilities.classification[value] || value;
}

function parseRate(value) {
  if (value == null || value === '') return NaN;
  return parseFloat(String(value).replace(',', '.'));
}

/** Classificação automática conforme fim e tipo de retorno. */
export function classificationFromPurpose(
  purpose,
  { returnType, taeg, expectedReturn } = {},
) {
  if (purpose === 'necessity' || purpose === 'desire') return 'bad';
  if (purpose !== 'investment') return 'bad';
  if (!returnType) return null;
  if (returnType === 'education' || returnType === 'other') return 'good';
  if (returnType === 'monetary') {
    const rate = parseRate(taeg);
    const ret = parseRate(expectedReturn);
    if (!Number.isNaN(rate) && !Number.isNaN(ret)) {
      return ret > rate ? 'good' : 'bad';
    }
    return 'good';
  }
  return 'good';
}

export function isInvestmentLosingMoney(purpose, returnType, taeg, expectedReturn) {
  if (purpose !== 'investment' || returnType !== 'monetary') return false;
  const rate = parseRate(taeg);
  const ret = parseRate(expectedReturn);
  return !Number.isNaN(rate) && !Number.isNaN(ret) && ret <= rate;
}

export function paymentRecurrenceLabel(value) {
  return pt.liabilities.form.paymentRecurrence[value] || value;
}
